import { DateTimeUtils } from "@sazka/utils/date-time-utils";
import { useDayjs } from "@sazka/utils/dayjs";
import duration, { DurationUnitType } from "dayjs/plugin/duration";

const { dayjs } = useDayjs();
dayjs.extend(duration);

interface LotteryCountdownConfig {
    days: boolean;
    hours: boolean;
    minutes: boolean;
    seconds: boolean;
}

export abstract class LotteryCountdown {
    public readonly game: string;
    public timeRemaining: plugin.Duration = null;
    protected units: Array<"days" | "hours" | "minutes" | "seconds"> = [];
    public readonly pattern?: string = null;

    constructor(config: LotteryCountdownConfig, game?: string, pattern?: string) {
        this.game = game || window.environment.game;

        switch (this.game) {
            case "stastnych-10":
                this.game = "stastnych10";
                break;
            case "sazkamobil-sance":
                this.game = "sazkamobil";
                break;
            case "stastne-datum":
                this.game = "stastnedatum";
                break;
            case "kostky":
                this.game = "kameny";
                break;
        }

        this.pattern = pattern;

        const keys = Object.keys(config) as Array<keyof typeof config>;

        keys.forEach((key) => config[key] && this.units.push(key));
    }

    getUnitText(unit: DurationUnitType, getTotalHours: boolean) {
        return DateTimeUtils.getCountdownUnitLength(this.timeRemaining, unit, getTotalHours);
    }

    localizeLabel(unit: DurationUnitType, value: unknown) {
        return DateTimeUtils.getCountdownUnitLabel(unit, value);
    }

    countdownReset(remainingSeconds: number): void {
        this.timeRemaining = dayjs.duration(remainingSeconds * 1000, "milliseconds");
        this.DomRender();
    }

    abstract DomRender(): void;
}
